import { Link, NavLink } from "react-router-dom";
import useAuthStore from "stores/AuthStore/AuthStore";
import { Button } from "antd";

const NAV_LINKS = [
  { label: "How it works", to: "/#earnings" },
  { label: "What you'd earn", to: "/calculator#estimate" },
];

function Navbar() {
  const isAuthenticated = useAuthStore((s) => Boolean(s.token && s.userData));

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-border/50 bg-background/80 backdrop-blur-xl">
      <div className="container mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center space-x-2.5">
          <img src="/shoup.svg" alt="ShoUp" className="h-8 w-8 rounded-lg" />
          <span className="text-lg font-bold tracking-tight">ShoUp</span>
        </Link>

        {!isAuthenticated && (
          <div className="hidden md:flex md:items-center md:gap-7">
            {NAV_LINKS.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors hover:text-foreground ${
                    isActive ? "text-foreground" : "text-muted-foreground"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        )}

        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <Link to="/shoup-community/dashboard">
              <Button type="primary" size="small">
                Dashboard
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/login">
                <Button type="text" size="small">
                  Log in
                </Button>
              </Link>
              <Link to="/signup">
                <Button type="primary" size="small">
                  Register your community
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
